import { css, nothing } from 'lit'
import HHQuizElement from '../element.js'
import { html } from 'lit/static-html.js'

/**
 * Results view
 * @extends
 */

class HHQuizViewResults extends HHQuizElement {
  static properties = {
    _isReady: { state: true, type: Boolean },
  }
  /**
   * Fetches remote results
   */
  connectedCallback() {
    super.connectedCallback()
    this.store.toggleStatic(true)
    if (this.router.current.params.handle === this.store.resultsHandle) {
      this._isReady = true
    } else {
      this._isReady = false
      this.fetch()
    }
  }

  async fetch() {
    const data = await this.store.fetchRemoteResults(this.router.current.params.handle)
    if (!data) {
      this.store.killLocalStorage()
      this.store.toggleStatic(false)
      this.router.go('/')
    } else {
      this._isReady = true
    }
  }

  /**
   * Renders the current route
   * @returns {TemplateResult}
   */
  render() {
    return this.store.isReady && this._isReady ? html`
      <hh-quiz-view-summary></hh-quiz-view-summary>
    ` : nothing
  }

  static styles = [
    HHQuizElement.styles,
    css`
    `,
  ]
}

customElements.define('hh-quiz-view-results', HHQuizViewResults)
